module.exports = __webpack_public_path__ + "static/img/tcrb.4fe4558d.svg";